<template>
    <main-section>
        <v-layout column justify-center align-center>
            <v-sheet width="400">
                <v-card-title> 로그인이 필요한 페이지입니다 </v-card-title>
                <v-card-text> <login-card /> </v-card-text>
            </v-sheet>
        </v-layout>
    </main-section>
</template>

<script>
import LoginCard from "@/components/client/login/login-card.vue";
import MainSection from "@/components/client/main/main-section.vue";
export default {
    components: {
        LoginCard,
        MainSection,
    },
};
</script>

<style>
</style>